<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-6">
        <div class="row">
          <div class="col-3 lbl">
            <label>Entité:</label>
          </div>
          <div class="col-9">
            <Dropdown
                class="input-width-100"
                v-model="entite"
                :options="entiteLibelles"
                optionValue="valeur"
                optionLabel="texte"
                scrollHeight="700px"
                :showClear="true"
            />
          </div>
        </div>
        <div class="row" v-if="cacherChampGenre==false">
          <div class="col-3 lbl">
            <label>Genre:</label>
          </div>
          <div class="col-9">
            <Dropdown
                class="input-width-100"
                v-model="genre"
                :options="genresLibelles"
                optionValue="valeur"
                optionLabel="texte"
                scrollHeight="205px"
                :showClear="true"
            />
          </div>
        </div>
        <div class="row" v-if="cacherChampIntervenant==false">
          <div class="col-3 lbl">
            <label>Intervenant:</label>
          </div>
          <div class="col-9">
            <Dropdown
                class="input-width-100"
                v-model="intervenant"
                :options="intervenantLibelles"
                optionValue="codeProfil"
                optionLabel="description"
                scrollHeight="700px"
                :showClear="true"
                filter
                filterPlaceholder="Rechercher..."
                filterMatchMode="startsWith"
            />
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="row">
          <div class="col-3 lbl">
            <label>Site d'origine:</label>
          </div>
          <div class="col-9">
            <Dropdown
                class="input-width-100"
                v-model="site"
                :options="sitesLibelles"
                optionValue="valeur"
                optionLabel="texte"
                scrollHeight="205px"
                :showClear="true"
            />
          </div>
        </div>
        <div class="row" v-if="cacherChampDate==false">
          <div class="col-3 lbl">
            <label>Du:</label>
          </div>
          <div class="col-9">
            <CustomInputDate
                class="input-width-100"
                type="date"
                max="9999-12-31"
                v-model="dateDu"
            />
          </div>
        </div>
        <div class="row" v-if="cacherChampDate==false">
          <div class="col-3 lbl">
            <label>Au:</label>
          </div>
          <div class="col-9">
            <CustomInputDate
                class="input-width-100"
                type="date"
                max="9999-12-31"
                v-model="dateAu"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import CustomInputDate from '../../Commun/CustomInputDate.vue'

export default {
  name: "CritereRechercheDivers",
  components: {
    CustomInputDate
  },
  props: {
    cacherChampDate: {
      type: Boolean,
      default: false,
    },
    cacherChampGenre: {
      type: Boolean,
      default: false,
    },
    cacherChampIntervenant: {
      type: Boolean,
      default: false,
    }
  },
  emits: ['rechercher'],
  data() {
    return {
      entite: null,
      entiteLibelles: [],
      site: null,
      sitesLibelles: [],
      genre: null,
      genresLibelles: [],
      intervenant: null,
      intervenantLibelles: [],
      criteresRecherche: {},
      dateAu: null,
      dateDu: null

    };
  },
  methods: {
    assignerListe(entiteDecision) {
      this.entiteLibelles = entiteDecision.entite.libelles;
      this.$store.dispatch("dossier/obtenirSiteEntiteAction").then((res) => {
        this.entite = res.data.entite;
        this.site = res.data.site;
        this.dateDefault();
      });
    },
    dateDefault() {
      let dateDefaut = new Date();
      this.dateDu = this.$commun.formatDate(dateDefaut.setDate(dateDefaut.getDate() - 7));
      this.dateAu = this.$commun.formatDate(new Date());
    },
    getCriteresRecherche() {
      if (this.dateAu !== null && this.dateAu !== undefined) {
        this.criteresRecherche.dateAu = new Date(this.dateAu);
      }
      if (this.dateDu !== null && this.dateDu !== undefined) {
        this.criteresRecherche.dateDu = new Date(this.dateDu);
      }
      this.criteresRecherche.genre = this.genre;
      this.criteresRecherche.entite = this.entite;
      this.criteresRecherche.intervenant = this.intervenant;
      this.criteresRecherche.site = this.site;

      return this.criteresRecherche;
    }
  },
  watch: {
    entite: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch("narration/onChangeEntityAction", {
          libelleChange: 'Site',
          nouvelleValeur: val
        })
            .then((res) => {
              this.sitesLibelles = res.data;
            });
        this.$store.dispatch('narration/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Genre',
          nouvelleValeur: val
        })
            .then((res) => {
              this.genresLibelles = res.data;
            });
      } else {
        this.site = null;
        this.sitesLibelles = [];
        this.genre = null;
        this.genresLibelles = [];
      }
    },
    site: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('dossier/obtenirListeIntervenantsAction', {
          site: val
        })
            .then((res) => {
              this.intervenantLibelles = res.data.sort(this.$commun.compareIntervenant);
            })
            .catch(() => {
              this.$toast.add({
                severity: 'warn',
                summary: 'Consignations',
                detail: 'La liste des intervenants n\'a   pas été remplie dans le délai normal.',
                life: 5000
              });
            })
      } else {
        this.intervenantLibelles = [];
        this.intervenant = null;
      }
    },
  }
}
</script>